
import { MAIN_PROPERTIES, MainPropertyKey, type HeatedSegment } from "../../state/properties.ts";
import { useStore } from "../../state/state.ts";
import { GEBAEUDE_TYP_OPTIONS, GebaeudeTyp, VerbrauchsEinheit } from "../../state/types.ts";
import ToggleInputGroup from "./input-toggle-group.tsx";
import SelectionInput from "./input-select.tsx";
import HeatedSegments from "./input-heated-segments.tsx";
import NumberInput from "./input-number.tsx";
import PlzInput from "./input-plz.tsx";
import YearInput from "./input-year.tsx";
import InputCheckbox from "./input-checkbox.tsx";
import InfoButton from "./info-button.tsx";
import ModalInfoSanierungsfahrplan from "../../modals/modal_info_sanierungsfahrplan.tsx";
import ModalInfoVersteuerndesHaushaltseinkommen from "../../modals/modal_info_versteuerndes_haushaltseinkommen.tsx";
import ModalInfoKlimageschwindigkeitsbonus from "../../modals/modal_info_klimageschwindigkeitsbonus.tsx";
import ModalInfoHeizkosten from "../../modals/modal_info_heizkosten.tsx";
import ModalInfoVollgeschosse from "../../modals/modal_info_vollgeschosse.tsx";
import ModalInfoWohneinheiten from "../../modals/modal_info_wohneinheiten.tsx";
import ModalInfoWohnflaeche from "../../modals/modal_info_wohnflaeche.tsx";
import ModalInfoKostensteigerung from "../../modals/modal_info_kostensteigerung.tsx";
import ModalInfoCO2Preis from "../../modals/modal_info_co2preis.tsx";
import ModalInfoStromverbrauch from "../../modals/modal_info_stromverbrauch.tsx";
import { ConfigContext } from "../../config_context.ts";
import {useContext} from "react";
import TextInput from "./input-text.tsx";
import ModalInfoHeizkessel from "../../modals/modal_info_heizkessel.tsx";
import ModalInfoWarmwasserReferenz from "../../modals/modal_info_warmwasser_referenz.tsx";
import { TranslationContext } from "../../translation.tsx";

export default function PropertyInput(props:{type: MainPropertyKey, placeholder_prefix?: string, placeholder_override?: string, unit_override?: string, label_override?: string}){
    const foerderung = useContext(ConfigContext).foerderung;
    const __ = useContext(TranslationContext).__;

    const one_click_house_type = useContext(ConfigContext).one_click_house_type;
    const increment_step = useStore((state) => state.increment_step);
    const plz_default = useContext(ConfigContext).plz_default;

    const key = props.type; 
    const value = useStore((state)=>state[key]);
    const baujahr = useStore((state)=>state.baujahr);
    const get_property_config = useStore((state)=>state.get_property_config);
    const get_property_label = useStore((state)=>state.get_property_label);
    const get_property_hint = useStore((state)=>state.get_property_hint);
    const measure_lables = useStore((state)=>state.measure_lables);
    const trade_measures = useStore((state)=>state.trade_measures);
    const get_measure_filter = useStore((state)=>state.get_measure_filter);
    const kwh_to_unit_current = useStore((state)=>state.kwh_to_unit_current);
    const unit_to_kwh_current = useStore((state)=>state.unit_to_kwh_current);
    const kwh_to_unit_planned = useStore((state)=>state.kwh_to_unit_planned);
    const unit_to_kwh_planned = useStore((state)=>state.unit_to_kwh_planned)
    const get_selected_unit_label_current = useStore((state)=>state.get_selected_unit_label_current);
    const get_selected_unit_current = useStore((state)=>state.get_selected_unit_current);
    const get_selected_unit_label_planned = useStore((state)=>state.get_selected_unit_label_planned);
    const get_selected_unit_planned = useStore((state)=>state.get_selected_unit_planned);

    const _set_property = useStore((state)=>state.set_property);
    const set_property = (k, v) => {
        _set_property(k, v);
    };
    const max_year = new Date().getFullYear();
    const min_year = baujahr || 1800;

    const config = get_property_config(key);
    if (config == undefined) {return <p>Propertie Schlüssel {key} nicht vorhanden</p>}
    
    
    let  placeholder = props.placeholder_override ?? config.placeholder;
    if(props.placeholder_prefix){
        placeholder = props.placeholder_prefix + " " + placeholder;
    }

    const set_property_dirty = (_:string)=>{};

      if (!foerderung && [
        "heizung_isfp",
        "keller_isfp",
        "dach_isfp",
        "fenster_isfp",
        "fassade_isfp",
        "solarthermie_isfp",
        "photovoltaik_isfp",
        "lueftung_isfp",
    ].includes(key)){
        return <></>;
    }
    
    const label = __(props.label_override || get_property_label(key));

    let input_body = null;

    let info_button = <></>;

    
    if ([
        "heizung_isfp",
        "keller_isfp",
        "dach_isfp",
        "fenster_isfp",
        "fassade_isfp",
        "solarthermie_isfp",
        "photovoltaik_isfp",
        "lueftung_isfp",
    ].includes(key)){
        info_button = <InfoButton label={label} modal={<ModalInfoSanierungsfahrplan/>}/>;
    }else if (key == "heizung_kosten"){
        info_button = <InfoButton label={label} modal={<ModalInfoHeizkosten/>}/>;
    }else if (key == "heizung"){
        info_button = <InfoButton label={label} modal={<ModalInfoHeizkessel/>}/>;
    }else if (key == "income_gt_4k"){
        info_button = <InfoButton label={label} modal={<ModalInfoVersteuerndesHaushaltseinkommen/>}/>;
    }else if (key == "heizung_wird_ausgetauscht"){
        info_button = <InfoButton label={label} modal={<ModalInfoKlimageschwindigkeitsbonus/>}/>;
    }else if (key == "vollgeschosse"){
        info_button = <InfoButton label={label} modal={<ModalInfoVollgeschosse/>}/>;
    }else if (key == "wohneinheiten"){
        info_button = <InfoButton label={label} modal={<ModalInfoWohneinheiten/>}/>;
    }else if (key == "wohnflaeche"){
        info_button = <InfoButton label={label} modal={<ModalInfoWohnflaeche/>}/>;
    }else if (key == "co2_price"){
        info_button = <InfoButton label={label} modal={<ModalInfoCO2Preis/>}/>;
    }else if (key == "kostensteigerung_energie"){
        info_button = <InfoButton label={label} modal={<ModalInfoKostensteigerung/>}/>;
    }else if (key == "stromverbrauch"){
        info_button = <InfoButton label={label} modal={<ModalInfoStromverbrauch/>}/>;
    }else if (key == "oelverbrauch"){
        info_button = <InfoButton label={label} modal={<ModalInfoWarmwasserReferenz/>}/>;
    }

    // const verbrauch_rounding = (value: number, unit: VerbrauchsEinheit) => {
    //     let v = Math.round(value);
    //     if(unit === "t"){
    //         v = value.toFixed(1) //(Math.round(value * 10) / 10);
    //     }
    //     return v;
    // };

    switch (config.type){
        case "boolean":
            input_body = <InputCheckbox infoButton={info_button} label={label} value={!!(value)} onChange={(value) => {set_property(key, value);}}/>;
            break;
        case "string":
            input_body = <TextInput infoButton={info_button} label={label} step={config.step} unit={config.unit} value={(value ?? "")}  placeholder={placeholder} onChange={(value) => {set_property(key, value);}} onBlur={()=>{set_property_dirty(key)}}/>;
            break;
        case "number":
            input_body = <NumberInput infoButton={info_button} label={label} max={config.max} min={config.min} step={config.step} unit={props.unit_override ? props.unit_override : config.unit} decimals={config.decimals || 0} value={value as number}  placeholder={placeholder} onChange={(value) => {set_property(key, value);}} onBlur={()=>{set_property_dirty(key)}}/>;
            break;
        case "number_with_unit_current":
            input_body = <NumberInput infoButton={info_button} label={label} max={config.max} min={config.min} decimals={2} step={config.step} unit={props.unit_override ? props.unit_override : "€/"+get_selected_unit_label_current()} value={ kwh_to_unit_current(value as number)}  placeholder={placeholder} onChange={(value) => {
                const v_u = unit_to_kwh_current(value);
                set_property(key, v_u);}
            } onBlur={()=>{set_property_dirty(key)}}/>;
            break;
        case "number_with_unit_planned":
            input_body = <NumberInput infoButton={info_button} label={label} max={config.max} min={config.min} decimals={2} step={config.step} unit={props.unit_override ? props.unit_override : "€/"+get_selected_unit_label_planned()} value={ kwh_to_unit_planned(value as number)}  placeholder={placeholder} onChange={(value) => {
                const v_u = unit_to_kwh_planned(value);
                set_property(key, v_u);}
            } onBlur={()=>{set_property_dirty(key)}}/>;
            break;        
         case "number_verbrauch_current":
            input_body = <NumberInput infoButton={info_button} label={label} max={config.max} min={config.min} step={config.step} unit={props.unit_override ? props.unit_override : config.unit} decimals={get_selected_unit_planned() == 't' ? 1 : 0} value={ unit_to_kwh_current(value) }  placeholder={placeholder} onChange={(value) => {
                const v_u = kwh_to_unit_current(value);
                set_property(key, Math.round(v_u)
                );}
            } onBlur={()=>{set_property_dirty(key)}}/>;
        break;
        case "number_verbrauch_planned":
            input_body = <NumberInput infoButton={info_button} label={label} step={config.step} unit={props.unit_override ? props.unit_override : config.unit} decimals={get_selected_unit_planned() == 't' ? 1 : 0} value={ unit_to_kwh_planned(value) }  placeholder={placeholder} onChange={(value) => {
                const v_u = kwh_to_unit_planned(value);
                set_property(key, Math.round(v_u)
                );}
            } onBlur={()=>{set_property_dirty(key)}}/>;
        break;
        case "plz":
            input_body =  <PlzInput label={label} value={value as number}  placeholder={plz_default} onChange={(value) => {set_property(key, value);}} onBlur={()=>{set_property_dirty(key)}}/>;
            break;
        case "year":
            input_body = <YearInput label={label} value={value as number} min={min_year} max={max_year}  placeholder={placeholder} onChange={(value) => {set_property(key, value);}} onBlur={()=>{set_property_dirty(key)}}/>;
            break;
        case "year_based":
                input_body = <YearInput label={label} value={baujahr as number}  min={1800} max={max_year} placeholder={placeholder} onChange={(value) => {set_property("baujahr", value);}} onBlur={()=>{set_property_dirty("baujahr")}}/>;
                break;
        case "options":
            input_body = <SelectionInput infoButton={info_button} label={label} value={value as string} options={
                config.options_key && trade_measures?.["measures"]?.[config.options_key] ? (
                    trade_measures["measures"][config.options_key]['options'][config.options_state]
                    .filter(get_measure_filter(config.options_key, config.options_state))
                    .filter(({code, label}) => (label != undefined && label != ""))
                    .sort((a,b) => a.sort_index - b.sort_index)
                    .map(
                        ({code, label})=>({
                            label,
                            value: code
                        })
                    )
                ) : (
                    config.options!.map((x)=>{
                        if (measure_lables == undefined){
                            return x;
                        }

                        return {
                            label: measure_lables[x.value] ?? x.label, 
                            value: x.value
                        }
                    })
                )
                
            } onChange={(value) => {
                    set_property(key, value);
              }} onBlur={()=>{
                //set_property(key, value as string);
                set_property_dirty(key)
            }}/>;
              break;
        case "gebaeude_typ":
            const gebaeude_typ_options_filter = useContext(ConfigContext).gebaeude_typ_options;
            const filtered_gebaeude_typ_options = gebaeude_typ_options_filter
                ? GEBAEUDE_TYP_OPTIONS.filter(o => gebaeude_typ_options_filter.includes(o.value))
                : GEBAEUDE_TYP_OPTIONS;
            input_body = <ToggleInputGroup<GebaeudeTyp> radio={true} label={label} arialabel="Gebäudetyp, bitte wählen Sie einen mit der Eingabetaste aus." value={value as GebaeudeTyp} options={filtered_gebaeude_typ_options} onChange={(options_key, value) => {
                set_property_dirty(key)
                if(value == true){
                    set_property(key, options_key);
                }
                if(one_click_house_type){
                    increment_step();
                }
              }}/>;
              break;
        case "heated_segments":
            input_body =   <HeatedSegments label={label} hint={get_property_hint(key)} value={value as HeatedSegment} onChange={(value) => {
                        set_property(key, value);
                  }}/>;
            break;
        default:
            input_body =  <></>;
            break;
    }

    return input_body;
    
  }